const GET: string = 'GET';
const POST: string = 'POST';

// Execute an HTTP GET request to a given URL
export const get = (url: string, options?: RequestInit): any => requestBase(url, GET, options);
export const getJSON = <T>(url: string, options?: RequestInit): Promise<T> => request(url, GET, options);

// Execute an HTTP POST request to a given URL
export const post = (url: string, options?: RequestInit): any => requestBase(url, POST, options);
export const postJSON = <T>(url: string, options?: RequestInit): Promise<T> => request(url, POST, options);

const request = async <T>(url: string, method: string, options?: RequestInit): Promise<T> => {
    return await requestBase(url, method, options).then(response => response.json() as Promise<T>);
}

const requestBase = async (url: string, method: string, options?: RequestInit): Promise<any> => {
    if (options) {
        options.method = method;
        //options.credentials = 'include';
        options.mode = 'cors';
    }
    else {
        options = {
            method: method,
            //credentials: 'include',
            mode: 'cors'
        };
    }
    return await fetch(url, options);
}
